import { useEffect, useState } from "react";

import { ERROR_MESSAGES } from "../constants/error_messages";
import { AuthService } from "../services/auth.service";

const authService = new AuthService();

export const useAuth = () => {
  const [mode, setMode] = useState<"login" | "signup">("login");

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string | undefined>();

  useEffect(() => {
    setErrorMsg(undefined);
  }, [mode]);

  const login = ({ email, password }: { email: string; password: string }) => {
    setLoading(true);

    authService
      .login({ email, password })
      .then(({ data }) => {
        console.log("data", data);
        localStorage.setItem("jwt", data.session.sessionId);
        window.dispatchEvent(new Event("storage"));
      })
      .catch((err) => {
        console.error(err);
        setErrorMsg(
          ERROR_MESSAGES[err.response.data.code] || err.response.data.code
        );

        setLoading(false);
      });
  };

  const signup = ({
    email,
    password,
    firstName,
    lastName,
    phoneNumber,
  }: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  }) => {
    setLoading(true);

    authService
      .signup({
        email,
        password,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber.replace(/\s/g, ""),
      })
      .then(({ data }) => {
        console.log("data", data);
        localStorage.setItem("jwt", data.session.sessionId);
        window.dispatchEvent(new Event("storage"));
      })
      .catch((err) => {
        console.error(err);

        setErrorMsg(
          ERROR_MESSAGES[err.response.data.code] || err.response.data.code
        );

        setLoading(false);
      });
  };

  return {
    mode,
    setMode,
    loading,
    errorMsg,
    login,
    signup,
  };
};
